// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'Feedbacks/List',
        method: 'post',
        data
    })
}

export const replyApi = (data) => {
    return request({
        url: 'Feedbacks/reply',
        method: 'post',
        data
    })
}